import Immutable from 'seamless-immutable';
// ---- external imports ----

import { ADS_STOP, ADS_RENT } from '../ads/actionTypes';
import { LOADING_TYPES } from '../../lib/constants';
import { CAR_LEASED, CAR_UNLEASED } from '../cars/actionTypes';
import { CHECKPOINT_RELOAD } from '../checkpoint/actionTypes';
import { EMPLOYEES_FIRE, EMPLOYEES_HIRE } from '../employees/actionTypes';
import { FINANCIAL_STATEMENTS_DISTRIBUTE_PROFIT, FINANCIAL_STATEMENTS_UPDATE_RATIOS_SUBMISSION_STATUS_FOR_QUARTER, FINANCIAL_STATEMENTS_UPDATE_SUBMISSION_STATUS_FOR_QUARTER } from '../financial-statements/actionTypes';
import { TRADESHOW_HIRE } from '../tradeshows/actionTypes';
import { WAREHOUSE_LEASED, WAREHOUSE_UNLEASED } from '../warehouses/actionTypes';
import { PRODUCTS_PURCHASED } from '../products/actionTypes';
import { TURN_FETCHING_NEXT } from '../turn/actionTypes';
import { GAME_LOADED } from '../game/actionTypes';
import { LEVEL_GO_TO_NEW_LEVEL } from '../level/actionTypes';
// ---- internal imports ----

import * as types from './actionTypes';
// ---- local imports ----


const initialState = Immutable({
	inProgressActions: [],
	loadingType: null,
	hasNetworkFailure: false,
});

function reduce(state = initialState, action = {}) {
	switch (action.type) {
	case types.LOADING_START:
		return getUpdatedStateAfterLoadingStartFor(state, action.actionType, action?.loadingType);

	case types.LOADING_END:
		return getUpdatedStateAfterLoadingEndFor(state, action.actionType, action?.loadingType);
	case types.LOADING_END_NETWORK_FAILURE:
		return getUpdatedStateAfterNetworkFailure(state);

	default:
		return state;
	}
}

function getUpdatedStateAfterLoadingStartFor(state, actionType) {
	if (!actionType || state.hasNetworkFailure) {
		//	it we have a network error
		//	then the loading is haulted
		return state;
	}

	if (isActionInProgress(state, actionType)) {
		return state;
	}

	const inProgressActions = [...state.inProgressActions, actionType];
	const nextLoadingType = getLoadingTypeFromInProgressActions(inProgressActions);

	return state.merge({
		inProgressActions: inProgressActions,
		loadingType: nextLoadingType
	});
}

function getUpdatedStateAfterLoadingEndFor(state, actionType) {
	if (!actionType || state.hasNetworkFailure) {
		//	it we have a network error
		//	then the loading is haulted
		return state;
	}

	if (!isActionInProgress(state, actionType)) {
		return state;
	}

	const inProgressActions = state.inProgressActions.filter((t) => t !== actionType);
	const nextLoadingType = getLoadingTypeFromInProgressActions(inProgressActions);

	return state.merge({
		inProgressActions,
		loadingType: nextLoadingType
	});
}

function getUpdatedStateAfterNetworkFailure(state) {
	return state.merge({
		inProgressActions: [],
		loadingType: null,
		hasNetworkFailure: true,
	});
}

function getLoadingTypeFromInProgressActions(inProgressActions) {
	//	returns the loading type (eg cursor or indicator)
	//	for the oldest action requiring a loading type
	if (inProgressActions.length === 0) {
		return null;
	}

	let loadingType = null;
	inProgressActions.forEach((action) => {
		if (!loadingType) {
			loadingType = LOADING_TYPES_BY_ACTION[action] ?? null;
		}
	});

	return loadingType;
}

const LOADING_TYPES_BY_ACTION = {
	[GAME_LOADED]:  LOADING_TYPES.INDICATOR,
	[PRODUCTS_PURCHASED]: LOADING_TYPES.INDICATOR,

	[TURN_FETCHING_NEXT]: LOADING_TYPES.CURSOR,
	[LEVEL_GO_TO_NEW_LEVEL]: LOADING_TYPES.CURSOR,

	[ADS_RENT]: LOADING_TYPES.CURSOR,
	[ADS_STOP]: LOADING_TYPES.CURSOR,

	[CAR_LEASED]: LOADING_TYPES.CURSOR,
	[CAR_UNLEASED]: LOADING_TYPES.CURSOR,

	[WAREHOUSE_LEASED]: LOADING_TYPES.CURSOR,
	[WAREHOUSE_UNLEASED]: LOADING_TYPES.CURSOR,

	[CHECKPOINT_RELOAD]: LOADING_TYPES.CURSOR, // or indicator

	[EMPLOYEES_HIRE]: LOADING_TYPES.CURSOR,
	[EMPLOYEES_FIRE]: LOADING_TYPES.CURSOR,

	[FINANCIAL_STATEMENTS_UPDATE_SUBMISSION_STATUS_FOR_QUARTER]: LOADING_TYPES.CURSOR,
	[FINANCIAL_STATEMENTS_UPDATE_RATIOS_SUBMISSION_STATUS_FOR_QUARTER]: LOADING_TYPES.CURSOR,
	[FINANCIAL_STATEMENTS_DISTRIBUTE_PROFIT]: LOADING_TYPES.CURSOR,

	[TRADESHOW_HIRE]:  LOADING_TYPES.CURSOR,
}

function isActionInProgress(state, actionType) {
	return state.inProgressActions.indexOf(actionType) !== -1;
}


export default reduce;
